export default {
  title: "Voici vos leviers d'actions qui peuvent améliorer votre Fiscalité :",
  tabs: {
    all: 'Tout afficher ({count})',
    optimizations: 'Optimisations fiscales ({count})',
    savings: 'Investir pour défiscaliser ({count})',
  },
  levers: {
    financialInvestment: {
      title: 'Investir dans les produits financiers avec un avantage fiscal',
      description: 'Certains investissements bénéficient d’avantages fiscaux afin de soutenir le financement de secteurs spécifiques.'
    },
    realEstateInvestment: {
      title: 'Investir dans l’immobilier avec un cadre fiscal avantageux',
      description: 'Certains investissements immobiliers bénéficient d’incitations offrant un cadre fiscal avantageux permettant de maîtriser sa fiscalité sur le revenu et ou la fortune immobilière pendant tout ou partie de la durée de l’investissement'
    },
  },
  noInvestmentsWarning: "Aucun investissement ne correspond à vos critères d'investissement"
}
